import { render, staticRenderFns } from "./ReferralAdd.vue?vue&type=template&id=49d26a40&"
import script from "./ReferralAdd.vue?vue&type=script&lang=js&"
export * from "./ReferralAdd.vue?vue&type=script&lang=js&"
import style0 from "./ReferralAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports